<template>
  <div class="gift-item-container normal-button" v-bind:class="{active: isActive}" @click="onClick">
    <div class="row-item">
      <img v-if="isActive" src="@/assets/radioactive.png" style="widht: 25px; height: 25px;" />
      <img v-else src="@/assets/radioinactive.png" style="widht: 25px; height: 25px;" />
      <span class="amount ml15">${{item.egift_amount}} Gift Card</span>
    </div>
    <div v-if="item.voucher_amount != null" class="row-item ml10 mt15">
      <img src="@/assets/pricetag.png" class="logo-price-tag" />
      <span class="gift-description ml10">
        Bonus
        <span class="amount gift-description">${{item.voucher_amount}}</span> service voucher
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "GiftItem",
  props: {
    item: {
      type: Object,
      isRequired: true
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {
    onClick() {
      this.$emit("onItemClick");
    }
  }
};
</script>
<style lang="scss" scoped>
.gift-item-container {
  display: flex;
  flex-direction: column;
  padding: 0 30px;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #eeeeee;
  margin: 0 10px 15px 10px;
  min-height: 96px;
  justify-content: center;
  .row-item {
    display: flex;
    align-items: center;
    .gift-description {
      font-size: 16px;
    }
  }
  .icon {
    font-size: 25px;
  }
  .logo-price-tag {
    width: 25px;
    height: auto;
  }
}
.active {
  background-color: #eeeeee;
}
</style>